import React, { FC, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { Button } from 'src/components/Button';
import { CustomFormulaValues } from 'src/components/Forms/CustomFormulaForm';
import { FilterCollapse } from 'src/components/Forms/CustomFormulaForm/Filters/FilterCollapse';
import {
  FilterCollapses,
  FiltersTabContent,
  Loader,
} from 'src/components/Forms/CustomFormulaForm/Filters/styled';
import { countFilledFilters, getIconForMetric } from 'src/utils';
import { CustomFormulaItemType } from 'src/utils/gql/types';
import { MetricsByConnectorType, ConnectorType } from 'src/utils/gql/types';

interface FiltersProps {
  onClickDelete: () => void;
  loading: boolean;
}

export const Filters: FC<FiltersProps> = ({ onClickDelete, loading }) => {
  const [expandedFilterCollapseId, setExpandedFilterCollapseId] = useState('');

  const { control } = useFormContext<CustomFormulaValues>();
  const formulaItems = useWatch({
    control,
    name: 'formulaItems',
  });

  const chosenMetrics = formulaItems.filter(
    (item) => item.type === CustomFormulaItemType.metric,
  );
  const hasAnyFilledFilters = formulaItems.some((item) =>
    countFilledFilters(item.filters || []),
  );

  const toggleFilterCollapse = (id: string) => {
    setExpandedFilterCollapseId((prevId) => (prevId === id ? '' : id));
  };

  return (
    <FiltersTabContent>
      {hasAnyFilledFilters && (
        <Button variant="text" endIcon={<DeleteIcon />} onClick={onClickDelete}>
          Delete filters
        </Button>
      )}
      <FilterCollapses>
        {formulaItems.map((metric, index) =>
          metric.type === CustomFormulaItemType.metric &&
          metric.connectorType &&
          metric.connectorType !== MetricsByConnectorType.CUSTOM_FORMULA ? (
            <FilterCollapse
              metricId={metric.metricId || ''}
              connectorType={metric.connectorType as ConnectorType}
              key={metric.id}
              formulaItemIndex={index}
              label={metric.label}
              expanded={expandedFilterCollapseId === metric.id}
              onToggle={() => toggleFilterCollapse(metric.id)}
              icon={getIconForMetric(metric.connectorType)}
            />
          ) : null,
        )}
        {!chosenMetrics.length && (
          <Typography margin="auto" fontWeight={600}>
            No Filters
          </Typography>
        )}
      </FilterCollapses>
      {loading && <Loader />}
    </FiltersTabContent>
  );
};
